<template>
   <div class="uploadList">
      <div v-for="(item,index) in this.attachTypeList">
         <!--附件类型-->
         <div class="uploadList_head">
            <p style="width: 80%; text-align: left; text-indent: -1.5em; padding-left: 1.5em;">{{ item.text }}</p>
            <div class="head_list" v-show="false" v-if="index ==1 && isEdit">
               <img src="@/assets/img/main/download.png" style="width: 20px;height: 20px;">
               <p @click="_downloadFile">点击下载</p>
            </div>
            <div class="head_list" v-if="isEdit">
               <img src="@/assets/img/banner/userlogin.png" style="width: 20px;height: 20px;">
               <p @click="_uploadFile(item.value,item.attachFile)">点击上传</p>
            </div>
         </div>
         <!--已上传附件列表-->
         <div class="uploadList_bot">
            <p v-for="itemSub in item.attachFile">
               <a target="_blank" :href="itemSub.url">{{ itemSub.name }}</a>
            </p>
         </div>
      </div>
      <div class="uploadBtn" style="margin-bottom: 10px;" v-if="isEdit">
         <el-button type="primary" @click="_submitApply">提交</el-button>
      </div>
      <div>
         <upload-file-dialog ref="upload" @uploadCompleted="_uploadComplete"></upload-file-dialog>
         <submit-dialog ref="submitDialog"></submit-dialog>
      </div>
   </div>
</template>
<script>
   import ruiTool from "@/utils/ruiTool";
   import {getApplyAttachList, getPrjUploadFiles} from '@/api/modules/paData'
   import uploadFileDialog from "@/views/techAchieveApply/components/uploadFileDialog";
   import submitDialog from "@/views/techAchieveApply/components/submitDialog";

   export default {
      data() {
         return {
            form: {
               project_code: '',
               project_application_id: '',
               projectType: '',
               opMode: '',
            },
            //显示的附件类型
            attachTypeList: [],
            //当前点击附件类型
            clickAttachType: '',
         }
      },
      components: {uploadFileDialog, submitDialog},
      created() {
         this.form.projectType = localStorage.getItem('projectType');
      },
      computed: {
         isEdit() {
            return this.form.opMode == 'edit';
         }
      },
      mounted() {
         //获取保存的传入参数
         this.form.project_application_id = localStorage.getItem("prjApplyCode")
         this.form.project_code = localStorage.getItem("prjCode");
         this.form.opMode = localStorage.getItem("opMode");

         //获取附件列表
         let param = {project_type: localStorage.getItem("projectType")}
         getApplyAttachList({
            data: param,
            success: (res) => {
               res.data.ddl.forEach((item, index) => {
                  this.attachTypeList.push({
                     value: item.value,
                     text: item.text,
                     attachFile: []
                  })
               })
            }
         })

         //修改模式 - 获取已上传的附件
         if (ruiTool.isNotNull(this.form.project_application_id)) {
            let param = {
               prjApplyId: this.form.project_application_id,
            }
            getPrjUploadFiles({
               data: param,
               success: (res) => {
                  //将返回的附件加入到对应的附件类型中
                  this.attachTypeList.forEach((type, index) => {
                     res.data.list.forEach((item, index) => {
                        if (type.value == item.type) {
                           type.attachFile.push({
                              name: item.data_name,
                              url: item.stored_path
                           });
                        }
                     })
                  })
               }
            })
         }
      },
      methods: {
         /*项目提交*/
         _submitApply() {
            this.form.project_application_id = localStorage.getItem("prjApplyCode")
            if (ruiTool.isNull(this.form.project_application_id)) {
               this.$message.error('请先保存基本信息');
               return
            }
            this.$refs.submitDialog.showDialog(this.form.project_application_id);
         },
         /*点击上传附件*/
         _uploadFile(attachType, fileList) {
            this.form.project_application_id = localStorage.getItem("prjApplyCode")
            if (ruiTool.isNull(this.form.project_application_id)) {
               this.$message.error('请先保存基本信息');
               return
            }
            this.clickAttachType = attachType
            //显示对话框传入数据
            this.$refs['upload'].showDialog(this.form.project_application_id, attachType, '.pdf', fileList)
         },
         //下载pdf模板
         _downloadFile() {
            this.form.project_application_id = localStorage.getItem("prjApplyCode")
            if (ruiTool.isNull(this.form.project_application_id)) {
               this.$message.error('请先保存基本信息');
               return
            }
            /*下载基本信息的PDF*/
            let pdfDomain = 'http://xiehui07.a6edu.net'
            if (this.form.projectType == '14') {
               const url = `${pdfDomain}/proapi/down/download-basic-msg?type=14&project_name=先进企业&project_app_num=${this.form.project_application_id}`
               window.open(url)
            }
            if (this.form.projectType == '16') {
               const url = `${pdfDomain}/proapi/down/download-basic-msg?type=16&project_name=优秀企业家&project_app_num=${this.form.project_application_id}`
               window.open(url)
            }
         },
         //接受上传对话框回传数据
         _uploadComplete(e) {
            console.log('成功后返回的数据', e);
            const attachType = e.attachType;
            const uploadFileList = e.uploadFileList;
            this.attachTypeList.forEach((item, index) => {
               if (item.value == attachType) {
                  item.attachFile = [];
                  uploadFileList.forEach((itemSub, indexSub) => {
                     item.attachFile.push({
                        name: itemSub.name,
                        url: itemSub.url
                     });
                  })
               }
            })
            console.log('返回的数据3', this.attachTypeList);
         },
      }
   }
</script>

<style scoped>
   .uploadList {
      border: 1px solid #f0f0f0;
      width: 90%;
      margin-top: 30px;
      margin-left: 5%;
      margin-right: 5%;
      margin-bottom: 10px;
   }

   .uploadList_head {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 40px 0 10px;
      line-height: 40px;
      font-size: 14px;
      border-bottom: 1px solid #f0f0f0;
   }

   .head_list {
      display: flex;
      align-items: center;
      cursor: pointer;
   }

   .uploadList_bot {
      padding-left: 1em;
      width: 80%;
      min-height: 30px;
      height: auto;
      display: flex;
      flex-wrap: wrap;
      align-content: space-around;
      justify-content: flex-start;
   }

   .uploadList_bot p {
      display: inline-block;
      height: 40px;
      line-height: 40px;
      color: #1890FF;
      text-decoration: underline;
      margin: 0 20px;
      cursor: pointer;
   }

   /* 上传样式 */
   .uploadContent {
      padding-top: 30px;
      padding-bottom: 30px;
   }

   .content_btn {
      display: flex;
      flex-flow: column;
      align-items: center;
      margin-bottom: 30px;
   }

   .content_btn p {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FE2C54;
   }

   .content_btn button {
      width: 150px;
      margin-top: 40px;
      margin-left: 440px;
   }
</style>